import { defs as apiDefs, api } from './api';

import { defs as clientDefs, client } from './client';

(window as any).defs = {
  api: apiDefs,
  client: clientDefs,
};
(window as any).API = {
  api,
  client,
};
